function tankMixCalculator() {

    $('.tank-mix-calculator form').each(function() {
        $(this).validate({
            rules: {
                capacity: {
                    required: true,
                    digits: true
                },
                rate: {
                    required: true,
                    digits: true
                }
            },
            messages: {
                capacity: {
                    required: 'Required',
                    digits: 'Whole numbers only'
                },
                rate: {
                    required: 'Required',
                    digits: 'Whole numbers only'
                }
            },
            errorPlacement: function(error, element) {
                error.insertAfter(element);
            }
        });
    });

    $('.tank-mix-calculator form').submit(function(e) {
        e.preventDefault();
        const $this = $(this),
              formID = $this.attr('id'),
              $resultCont = $('[data-calculator="' + formID + '"]');
              capacity = $('input[name="capacity"]', this).val(),
              rate = $('input[name="rate"]', this).val();

        if ($this.valid()) {
            let gallons,
                acres,
                carrier,
                total;
            
            if (formID == 'tank-mix') {
                gallons = ((capacity / rate) * 0.1).toFixed(2);
                acres = (capacity / rate).toFixed(2);
                carrier = (capacity - (capacity / rate) * 0.1).toFixed(2);
                total = (capacity / rate / 40).toFixed(2);
            } else {
                gallons = (capacity * 4).toFixed(2);
                acres = (capacity * 40).toFixed(2);
                carrier = (capacity * 40 * rate - capacity * 4).toFixed(2);
                total = (capacity * 40 * rate).toFixed(2);
            }

            $('span[data-label="gallons"]', $resultCont).text(gallons);
            $('span[data-label="acres"]', $resultCont).text(acres);
            $('span[data-label="carrier"]', $resultCont).text(carrier);
            $('span[data-label="total"]', $resultCont).text(total);
        } else {
            $this.siblings('.results-container').find('.result-value').text('— —');
        }
    });

}